var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutboundAnswer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_14369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 0.666504H5.2145L6.05833 4.88562L4.27723 6.66672C4.96779 9.10832 6.89282 11.0333 9.33442 11.7239L11.1155 9.94281L15.3346 10.7866V15.3332H11.3346C5.4436 15.3332 0.667969 10.5575 0.667969 4.6665V0.666504ZM2.0013 1.99984V4.6665C2.0013 9.82116 6.17998 13.9998 11.3346 13.9998H14.0013V11.8797L11.5538 11.3902L9.74781 13.1961L9.38817 13.1136C6.16406 12.3734 3.6277 9.83708 2.88756 6.61297L2.805 6.25333L4.61094 4.44739L4.12143 1.99984H2.0013Z",
    fill: "#697180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5262 1H15.0011V5.47492H13.5094V3.54639L9.78034 7.27549L8.72559 6.22074L12.4547 2.49164H10.5262V1Z",
    fill: "#16A24A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_14369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundAnswer);
export default __webpack_public_path__ + "static/media/outbound_answer.74baee5450ae986d790b0880dc73f333.svg";
export { ForwardRef as ReactComponent };